import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const CircleLayer = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 12C4.2 12 2 14.2 2 17C2 19.8 4.2 22 7 22C9.8 22 12 19.8 12 17C12 14.2 9.8 12 7 12ZM11 7C8.6 7 6.4 8.5 5.5 10.7C9 9.8 12.5 12 13.3 15.4C13.6 16.4 13.6 17.5 13.3 18.5C16.4 17.2 17.8 13.7 16.5 10.7C15.6 8.5 13.4 7 11 7ZM21.2 5.8C20.1 3.5 17.6 2 15 2C12.4 2 9.9 3.5 8.8 5.8C12.8 4.6 17 6.8 18.2 10.7C18.7 12.2 18.7 13.7 18.2 15.2C21.6 13.5 23 9.3 21.2 5.8Z"
      fill="currentColor"
    />
  </svg>
)

export default CircleLayer
